export class DeviceKrpano {
    constructor(_krpano) {
        this._krpano = _krpano;
        this.isMacOrRetina = () => {
            return this._isRetina() || this._isMac() || this._isiOS();
        };
        this._isRetina = () => this._krpano.get('device.retina');
        this._isiOS = () => this._krpano.get('device.ios');
        this._isMac = () => this._krpano.get('device.mac');
    }
}
